import { createSlice } from "@reduxjs/toolkit";
import assignPick from "../utils/assignPick";
import {
  MODE,
  parseSelfcheckoutMode,
  parseTableLocation,
} from "../utils/selfcheckoutMode";

const initialState = Object.freeze({
  id: 0,
  uri: "",
  name: "",
  phone: "",
  whatsapp: "",
  manualAddressEnable: false,
  addressStreet: "",
  addressNumber: "",
  complement: "",
  neighborhood: "",
  city: "",
  state: "",
  postalCode: "",
  pictureUrl: "",
  emergencyPause: null,
  workingScheduleInloco: [],
  workingScheduleDelivery: [],
  workingScheduleToGo: [],
  deliveryFees: [],
  availablePaymentsToGo: [],
  availablePaymentsDelivery: [],
  deliveryEnable: false,
  deliveryMinimalCost: "",
  takeoutEnable: false,
  takeoutDiscount: "",
  informationHeader: "",
  informationFooter: "",
  mercadoPagoKey: "",
  mercadoPagoLogin: false,
  mercadoPagoCartao: false,
  mercadoPagoPix: false,
  pizzaPriceMode: "",
  utcOffsetMinutes: null,
  isAvailableToOrder: false,
  messageToOrder: "Este menu é apenas para visualização.",
  isInLoco: false,
  orderLocation: "",
  tableId: "",
  inLocoCmd: false,
  inLocoTitle: "",
  inLocoText: "",
  isInLocoConfirmed: false,
  messageOrderSuccess: "",
  layoutGroupsFirst: false,
  kilogramStep: 0.1,
  isWhatsappSendingEnabled: false,
  user18Older: false,

  // ver utils/selfcheckoutMode.js
  mode: MODE.DELIVERY,
  isSelfcheckout: false,
  isSelfcheckoutPOS: false,
  isSelfcheckoutQRCode: false,
  isSelfcheckoutTotem: false,
  isSelfOrderTable: false,
  isSelfOrderScanQRCode: false,

  totemName: "",
  totemTefModel: "",

  fidelity: {},
  isOrderSchedulingEnabled: false,
  daysAheadToSchedule: 0,

  backgroudColor: null,
  textColor: null,
  selfcheckoutConfigs: [],
});

// Estado da sessão, vindo da URL ou do próprio aparelho, e não do cadastro da
// loja. O setShopDetails roda de novo a cada republicação (polling do
// autoatendimento) e não pode sobrescrever nada disto.
const SESSION_KEYS = [
  "mode",
  "isInLoco",
  "orderLocation",
  "tableId",
  "isInLocoConfirmed",
  "user18Older",
  "isSelfcheckout",
  "isSelfcheckoutPOS",
  "isSelfcheckoutQRCode",
  "isSelfcheckoutTotem",
  "isSelfOrderTable",
  "isSelfOrderScanQRCode",
  "totemName",
  "totemTefModel",
];

const SHOP_DETAILS_KEYS = Object.keys(initialState).filter(
  (key) => !SESSION_KEYS.includes(key),
);

export const shopSlice = createSlice({
  name: "shop",
  initialState,
  reducers: {
    setShopDetails: (state, { payload }) => {
      assignPick(state, payload, SHOP_DETAILS_KEYS);

      if (state.isSelfOrderTable) {
        const { title, text } = parseTableLocation(state.tableId);
        state.inLocoTitle = title;
        state.inLocoText = text;
        return;
      }

      if (state.isSelfcheckout) {
        state.inLocoText = null;
        return;
      }

      if (state.isInLoco) {
        state.inLocoTitle = state.inLocoCmd ? "Comanda" : "Mesa";
        state.inLocoText = Number(state.tableId)
          ? `${state.inLocoTitle} ${state.tableId}`
          : state.tableId;
      }
    },
    setOrderAvailability: (state, { payload }) => {
      state.isAvailableToOrder = !!payload.isAvailableToOrder;
    },
    setInLoco: (state, { payload }) => {
      state.orderLocation = payload.orderLocation;
      state.isInLoco = !!payload.isInLoco;
      Object.assign(state, parseSelfcheckoutMode(payload));
    },
    setInLocoConfirmed: (state, { payload }) => {
      state.isInLocoConfirmed = payload.isInLocoConfirmed;
    },

    setUser18Older: (state, { payload }) => {
      state.user18Older = payload.user18Older;
    },
    setTotemData: (state, { payload }) => {
      state.totemName = payload.nome;
      state.totemTefModel = payload.tef_modelo;
    },
  },
});

export const {
  setShopDetails,
  setOrderAvailability,
  setInLoco,
  setInLocoConfirmed,
  setUser18Older,
  setTotemData,
} = shopSlice.actions;

export default shopSlice.reducer;
